import { useEffect, useRef } from 'react';
import { Platform } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { SCROLLBAR_WIDTH_PX } from './useCustomVisibleScrollbar.constants';

// Dynamically inject CSS only once when the module is imported.
// This approach allows us to use the SCROLLBAR_WIDTH_PX variable, 
// which is not possible in a separate static CSS file.
const injectCustomScrollbarStyles = () => {
  if (typeof document !== 'undefined' && !document.getElementById('custom-scrollbar-styles')) {
    const style = document.createElement('style');
    style.id = 'custom-scrollbar-styles';
    style.innerHTML = `
      .scrollViewCustom::-webkit-scrollbar {
        width: ${SCROLLBAR_WIDTH_PX}px;
      }
      .scrollViewCustom::-webkit-scrollbar-track {
        background: #f1f1f1;
      }
      .scrollViewCustom::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 5px;
      }
      .scrollViewCustom::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    `;
    document.head.appendChild(style);
  }
};

// Hook that returns a ref and assigns a custom class to the scrollable node.
/**
 * Hook that assigns the `scrollViewCustom` class to the scrollable node of a `ScrollView`
 * ONLY on Web, to apply custom scrollbar styles.
 * Returns a `ref` that should be attached to the `ScrollView` component.
 */
export function useCustomScrollbar() {
  const scrollViewRef = useRef<ScrollView>(null);

  useEffect(() => {
    if (Platform.OS === 'web') {
      injectCustomScrollbarStyles();

      if (scrollViewRef.current) {
        const node = (scrollViewRef.current as any).getScrollableNode();
        if (node) {
          node.classList.add('scrollViewCustom');
        }
      }
    }
  }, []);

  return scrollViewRef;
}
